export type UsageMetric = "count" | "cost" | "price";

export interface UsageInterval {
  agg_count?: number;
  agg_cost?: number;
  agg_price?: number;
  ai_query_assist_count?: number;
  ai_query_assist_cost?: number;
  ai_query_assist_price?: number;
  "ai_summary+ai_social_personas_count"?: number;
  "ai_summary+ai_social_personas_cost"?: number;
  "ai_summary+ai_social_personas_price"?: number;
  date: string;
  records_count?: number;
  records_cost?: number;
  records_price?: number;
  "topics+clusters_count"?: number;
  "topics+clusters_cost"?: number;
  "topics+clusters_price"?: number;
}

export type UsageIntervalKey = keyof UsageInterval;

type UsageCategory = {
  agg: number;
  ai_query_assist: number;
  "ai_summary+ai_social_personas": number;
  records: number;
  "topics+clusters": number;
}

export type UsageCategoryKey = keyof UsageCategory;

type UsageCategoryObj = Record<UsageCategoryKey, undefined>;
const usageCategoryProperties: UsageCategoryObj = {
  agg: undefined,
  ai_query_assist: undefined,
  "ai_summary+ai_social_personas": undefined,
  records: undefined,
  "topics+clusters": undefined
};
const UsageCategoryList = Object.keys(usageCategoryProperties) as Array<UsageCategoryKey>;
export function getUsageCategoryList() {
  return [...UsageCategoryList];
}

export type UsageBucket = {
  [Property in UsageCategoryKey]?: number;
}

export interface TotalUsage {
  cost: UsageBucket;
  count: UsageBucket;
  price: UsageBucket;
}

export interface TokenUsage {
  cost: UsageBucket;
  count: UsageBucket;
  description: string | null;
  id: string;
  price: UsageBucket;
}

export interface UserUsage {
  email: string;
  id: string;
  name: string;
  tokens?: Array<TokenUsage>;
}

export interface Usage {
  currency: string;
  quota: boolean;
  since: string;
  term_end: string;
  term_start: string;
  timeline: Array<UsageInterval>;
  token_type: "api" | "web";
  total: TotalUsage;
  until: string;
  user_id: string;
  users: Array<UserUsage>;
}